import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import ChatInterface from './ChatInterface';

interface chatInterfaceProps {
  isOpen: boolean;
  onClose: () => void;
}

const ChatInterfaceModal: React.FC<chatInterfaceProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Chat Interface</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <ChatInterface onClose={onClose}/>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ChatInterfaceModal;
